import { Case, CaseComplainantType } from '@/@types/generated'
import { MessageSquareWarningIcon } from 'lucide-react'
import {
  CaseComplainantTypesProvider,
  useCaseComplainantTypes,
} from '../hooks/case-complainants-types'
import SelectTypeButton, { SelectTypeButtonProps } from './SelectTypeButton'

interface CaseComplainantTypeButtonProps {
  case: Case
  onChange: SelectTypeButtonProps<CaseComplainantType>['onChange']
  disabled?: boolean
}

export default function CaseComplainantTypeButton({
  ...props
}: CaseComplainantTypeButtonProps) {
  return (
    <CaseComplainantTypesProvider>
      <Inner {...props} />
    </CaseComplainantTypesProvider>
  )
}

function Inner({
  case: _case,
  disabled,
  onChange,
}: CaseComplainantTypeButtonProps) {
  // Hooks
  const { caseComplainantTypes } = useCaseComplainantTypes()

  return (
    <SelectTypeButton
      label="Complainant Type"
      options={caseComplainantTypes}
      value={_case.complainantType || null}
      valueIcon={<MessageSquareWarningIcon className="stroke-primary" />}
      disabled={disabled}
      onChange={onChange}
    />
  )
}
